import { useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";

import "../Campaigns/campaigns.scss";
import { Dialog, makeStyles } from "@material-ui/core";

import Title from "../../uiKit/Title/Title";
import CustomInput from "../../uiKit/Input/CustomInput";
import CustomCheckbox from "../../uiKit/CustomCheckbox/customCheckbox";
import CustomButton from "../../uiKit/Button/CustomButton";
import Divider from "../../uiKit/assets/svg/divider.svg";
import { validateEmail, validateName } from "../../helpers/validation";
import LoginComponent from "../Login/loginComponent";

import { login } from "../../redux/state/accountSlice";
import {
  setJoinCommunity,
  setUserEmail,
  setUserFirstName,
  setUserInfoError,
  setUserLastName,
} from "../../redux/state/donationSlice";

const useDialogStyles = makeStyles(() => ({
  paper: {
    "&.MuiPaper-rounded": {
      borderRadius: "12px",
    },
  },
}));

const Donate = () => {
  const dispatch = useDispatch();

  const firstName = useSelector((state) => state.donation.body.userInfo.firstName);
  const lastName = useSelector((state) => state.donation.body.userInfo.lastName);
  const email = useSelector((state) => state.donation.body.userInfo.email);
  const joinCommunity = useSelector((state) => state.donation.joinCommunity);

  const [errors, setErrors] = useState({
    firstNameError: "",
    lastNameError: "",
    emailError: "",
  });

  const onFirstNameChange = (e) => {
    const value = e.target.value;
    dispatch(setUserFirstName(value));
    dispatch(setUserInfoError(!validateName(value)));
    if (!validateName(value)) {
      setErrors((prev) => ({ ...prev, firstNameError: "Invalid first name" }));
    } else {
      setErrors((prev) => ({ ...prev, firstNameError: "" }));
    }
  };

  const onLastNameChange = (e) => {
    const value = e.target.value;
    dispatch(setUserLastName(value));
    dispatch(setUserInfoError(!validateName(value)));
    if (!validateName(value)) {
      setErrors((prev) => ({ ...prev, lastNameError: "Invalid last name" }));
    } else {
      setErrors((prev) => ({ ...prev, lastNameError: "" }));
    }
  };

  const onEmailChange = (e) => {
    const value = e.target.value;
    dispatch(setUserEmail(value));
    dispatch(setUserInfoError(!validateEmail(value)));
    if (!validateEmail(value)) {
      setErrors((prev) => ({ ...prev, emailError: "Email is not valid" }));
    } else {
      setErrors((prev) => ({ ...prev, emailError: "" }));
    }
  };

  const onJoinCommunityChange = () => dispatch(setJoinCommunity(!joinCommunity));

  return (
    <>
      <CustomInput
        label="First name"
        value={firstName}
        onChange={onFirstNameChange}
        error={!!errors.firstNameError}
        errorMessage={errors.firstNameError}
        maxLength={30}
      />
      <CustomInput
        label="Last name"
        value={lastName}
        onChange={onLastNameChange}
        error={!!errors.lastNameError}
        errorMessage={errors.lastNameError}
        maxLength={30}
      />
      <CustomInput
        label="email"
        value={email}
        onChange={onEmailChange}
        error={!!errors.emailError}
        errorMessage={errors.emailError}
      />
      <CustomCheckbox
        label="Become a member of community"
        checked={joinCommunity}
        onChange={onJoinCommunityChange}
        height="max-content"
      />
      <div className="divider" />
    </>
  );
};

export const SignInComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const dialogClasses = useDialogStyles();

  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);

  const [loginOpen, setLoginOpen] = useState(false);

  const loginHandler = ({ email, password, remember }) => {
    const communityId = query.get("communityId");
    const campaignId = query.get("campaignId");
    dispatch(login({ email, password, remember }))
      .then(unwrapResult)
      .then(() => {
        history.push(`/campaigns/campaign/active/${communityId}/${campaignId}`);
      })
      .catch(({ title }) => console.error(title));
  };

  return (
    <>
      <Title text="Do you have account?" fontWeight={400} style={{ marginBottom: "24px" }} />
      <CustomButton
        title="Sign in"
        isWhite
        style={{ marginBottom: "24px" }}
        onClick={() => setLoginOpen(true)}
      />
      <img src={Divider} alt="divider" style={{ width: "100%", marginBottom: "16px" }} />
      <Dialog
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        disableScrollLock={true}
        classes={dialogClasses}
      >
        <div className="page">
          <LoginComponent onLogin={loginHandler} createAccount={false} hasBackground={false} />
        </div>
      </Dialog>
    </>
  );
};

export default Donate;
